export default {
  approvalDetails: (state) => state.approvalDetails
};
